export function parseHTMLFromString(htmlString) {
	if (!htmlString) {
		return false;
	}

	const range = document.createRange();
	const documentFragment = range.createContextualFragment(htmlString);
	return documentFragment;
}
